import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPudIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 145,
	height: 145,
	viewBox: "0 0 145 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M72.395 143.435C111.629 143.435 143.435 111.629 143.435 72.395C143.435 33.1607 111.629 1.35498 72.395 1.35498C33.1606 1.35498 1.35498 33.1607 1.35498 72.395C1.35498 111.629 33.1606 143.435 72.395 143.435Z",
			stroke: "white",
			strokeWidth: 2.71,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.0051 96.805C30.6851 94.705 27.7051 90.275 27.7051 85.145V50.375C27.7051 43.215 33.5051 37.415 40.6651 37.415",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.4552 98.105H57.3052",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.625 37.415C87.785 37.415 93.585 43.215 93.585 50.375V88.345",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.585 58.735H109.075C114.455 58.735 118.825 63.095 118.825 68.485V96.815H104.015",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.6652 107.065C99.8346 107.065 104.025 102.874 104.025 97.705C104.025 92.5356 99.8346 88.345 94.6652 88.345C89.4958 88.345 85.3052 92.5356 85.3052 97.705C85.3052 102.874 89.4958 107.065 94.6652 107.065Z",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.3249 107.065C51.4942 107.065 55.6848 102.874 55.6848 97.705C55.6848 92.5356 51.4942 88.345 46.3249 88.345C41.1555 88.345 36.9648 92.5356 36.9648 97.705C36.9648 102.874 41.1555 107.065 46.3249 107.065Z",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.425 76.615C107.605 76.615 100.455 69.465 100.455 60.645",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.645 44.005V67.225",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.215 64.895L60.645 73.465L52.085 64.895",
			stroke: "white",
			strokeWidth: 5.57,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPudIcon;
